import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PaginatedResponse} from '../../models/paginatedResponse';
import {Fournisseur} from '../../models/fournisseur';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FournisseurService {
    private apiUrl = `${environment.fournisseur_url}api`;

    constructor(private http: HttpClient) {}

    getActiveFournisseur(stationId: number, page: number, limit: number): Observable<PaginatedResponse<Fournisseur>> {
        return this.http.get<PaginatedResponse<Fournisseur>>(`${this.apiUrl}/fornisseurs/station/${stationId}?page=${page}&limit=${limit}`);
    }

    getArchivedFournisseur(stationId: number, page: number, limit: number): Observable<PaginatedResponse<Fournisseur>> {
        return this.http.get<PaginatedResponse<Fournisseur>>(`${this.apiUrl}/fornisseurs/station/${stationId}/archive?page=${page}&limit=${limit}`);
    }

    getActiveFournisseurCount(stationId: number): Observable<number> {
        return this.http.get<PaginatedResponse<Fournisseur>>(`${this.apiUrl}/fornisseurs/station/${stationId}?page=1&limit=1`)
            .pipe(map(response => response.meta?.total || 0));
    }

    getArchivedFournisseurCount(stationId: number): Observable<number> {
        return this.http.get<PaginatedResponse<Fournisseur>>(`${this.apiUrl}/fornisseurs/station/${stationId}/archive?page=1&limit=1`)
            .pipe(map(response => response.meta?.total || 0));
    }

    getFournisseurById(fournisseurId: number | string): Observable<Fournisseur> {
        return this.http.get<Fournisseur>(`${this.apiUrl}/fornisseurs/${fournisseurId}`);
    }

    addFournisseur(fournisseur: Fournisseur): Observable<Fournisseur> {
        return this.http.post<Fournisseur>(`${this.apiUrl}/fornisseurs`, fournisseur);
    }

    updateFournisseur(fournisseurId: number, fournisseur: Partial<Fournisseur>): Observable<Fournisseur> {
        return this.http.put<Fournisseur>(`${this.apiUrl}/fornisseurs/${fournisseurId}`, fournisseur);
    }

    archiveFournisseur(fournisseurId: number, is_archive: boolean): Observable<Fournisseur> {
        return this.http.patch<Fournisseur>(`${this.apiUrl}/fornisseurs/${fournisseurId}/archive`, { is_archive });
    }

    /**
     * Envoyer un email à un fournisseur
     * @param fournisseurId ID du fournisseur
     * @param emailData Données de l'email (to, cc, subject, message, user_id)
     */
    sendEmail(fournisseurId: number, emailData: { to: string; cc?: string; subject: string; message: string; user_id: number }): Observable<any> {
        console.log('📧 [FournisseurService.sendEmail] Envoi email pour fournisseur:', fournisseurId);
        console.log('📧 [FournisseurService.sendEmail] Données email:', emailData);
        return this.http.post(`${this.apiUrl}/fornisseurs/${fournisseurId}/send-email`, emailData);
    }
}
